// extracted by mini-css-extract-plugin
export var fullHeightState = "_6b-7";
export var headerCell = "_6b-1";
export var loadingStateCell = "_6b-4";
export var rowWrapper = "_6b-3";
export var standaloneTable = "_6b-8";
export var standaloneTableWithBodyFill = "_6b-9";
export var stateCell = "_6b-5";
export var table = "_6b-0";
export var tableBodyFiller = "_6b-6";
export var white = "_6b-2";